import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyCallButton from "./StickyCallButton";
import { Toaster } from "./ui/sonner";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="site-layout">
      <Navbar />
      <main className="flex-1 pt-32">{children}</main>
      <Footer />
      <StickyCallButton />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
};

export default Layout;
